import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, Optional } from "@angular/core";
import { SerprobotsConfig } from "../../serprobots-config";
import { SERPROBOTS_CONFIG_TOKEN } from "../../serprobots-config.token";
import { Configuration } from "../configuration";

/**
 * Serviço que obtém o JSON de configuração.
 * 
 * Trata-se de um "helper", que facilita a obtenção da configuração
 * em algum endereço.
 */
@Injectable({providedIn: "root"})
export class ConfigurationLoader {

    private configuration?: Configuration;

    constructor(
        private http: HttpClient,
        
        @Optional() @Inject(SERPROBOTS_CONFIG_TOKEN) 
        private readonly config: SerprobotsConfig | null
    ) {}

    /**
     * Obtém o JSON de configuração.
     * 
     * Caso não seja fornecida uma URL, a busca pelo JSON será realizada
     * no endereço padrão "assets/config/json", considerando que o projeto
     * já carrega consigo uma configuração padrão.
     * 
     * @param url URL onde deve obter o JSON.
     * @returns Configuração.
     */
    async getConfiguration({url = "assets/config.json"} : { url?: string } = {}): Promise<Configuration> {
        var result: Configuration;

        if (this.configuration) {
            result = this.configuration;
        } else {
            var useThis = url;

            if (this.config?.configurationURL) {
                useThis = this.config.configurationURL;
            }

            try {
                result = await this.http.get<Configuration>(useThis).toPromise();
                result = Object.assign(new Configuration({}), result);
            } catch(error) {
                throw new Error(`Não foi possível obter o arquivo de configuração do endereço ${useThis}`);
            }

            // A URL onde se encontra a configuração pode ser definida como um parâmetro da UI no Serprobots.
            // Portanto, é necessário verificar o atributo configurationURL. Caso ele esteja definido, significa que a URL
            // onde se encontra a configuração é outra.
            if (result.configurationURL) {
                try {
                    result = await this.http.get<Configuration>(result.configurationURL).toPromise();
                    result = Object.assign(new Configuration({}), result);
                } catch(error) {
                    console.log(`Não foi possível obter o arquivo de configuração externo em ${result.configurationURL}. Usando arquivo padrão.`);
                }
            }

            this.configuration = result;
        }

        return result;
    }

}